/* ── CURSOR — single dot, colour-inverting ── */
  (function(){
    var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if(!mq.matches || rm.matches) return;

    var dot = document.getElementById('c-dot');
    if(!dot) return;

    /* Start off-screen */
    dot.style.left = '-40px';
    dot.style.top  = '-40px';
    var visible = false;

    /* Dot tracks mouse exactly — this IS the click point */
    document.addEventListener('mousemove', function(e) {
      dot.style.left = e.clientX + 'px';
      dot.style.top  = e.clientY + 'px';
      if(!visible){ dot.style.opacity = '1'; visible = true; }
    }, { passive: true });

    /* Size changes on interactive elements */
    var TARGETS = 'a, button, [role="button"]';
    document.addEventListener('mouseover', function(e) {
      var el = e.target.closest(TARGETS);
      if(!el) return;
      document.body.classList.remove('ch','cl','cc');
      document.body.classList.add(el.tagName === 'A' ? 'cl' : 'ch');
    });
    document.addEventListener('mouseout', function(e) {
      if(e.target.closest(TARGETS)) document.body.classList.remove('ch','cl');
    });

    /* Shrink on click */
    document.addEventListener('mousedown', function(){ document.body.classList.add('cc'); });
    document.addEventListener('mouseup',   function(){ document.body.classList.remove('cc'); });

    /* Fade out when leaving viewport */
    document.addEventListener('mouseleave', function(){ dot.style.opacity = '0'; visible = false; });
    document.addEventListener('mouseenter', function(){ dot.style.opacity = '1'; visible = true; });
  })();

    /* ── NAV ── */
  const navEl=document.getElementById('nav');
  const navAlwaysSolid = navEl.dataset.solid === 'true';
  window.addEventListener('scroll',()=>{
    if(navAlwaysSolid){ navEl.classList.add('sc'); return; }
    navEl.classList.toggle('sc', scrollY > 60);
  },{passive:true});

  /* ── MOBILE MENU ── */
  const tog=document.getElementById('nav-tog'),mob=document.getElementById('mob'),mobX=document.getElementById('mob-x');
  tog.addEventListener('click',()=>{
    const o=!mob.hidden;
    mob.hidden=o;
    mob.classList.toggle('open',!o);
    tog.setAttribute('aria-expanded',String(!o));
    // Prevent body scroll when menu open
    document.body.style.overflow = o ? '' : 'hidden';
    // Always force nav solid when menu opens so hamburger is visible on return
    if(!o){ navEl.classList.add('sc'); mob.querySelector('a').focus(); }
  });
  mobX.addEventListener('click',closeMob);
  function closeMob(){
    mob.hidden=true;
    mob.classList.remove('open');
    tog.setAttribute('aria-expanded','false');
    document.body.style.overflow='';
    // Restore transparent nav on homepage if at top
    if(!navAlwaysSolid && scrollY <= 60) navEl.classList.remove('sc');
    tog.focus();
  }
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!mob.hidden)closeMob();});

  /* ── REVEAL ── */
  const ro=new IntersectionObserver((entries)=>{
    entries.forEach((e,i)=>{
      if(e.isIntersecting){
        e.target.style.transitionDelay=`${i*.06}s`;
        e.target.classList.add('visible');
        ro.unobserve(e.target);
      }
    });
  },{threshold:.1,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.reveal').forEach(el=>ro.observe(el));

  /* ── QUIZ ── */
  let cs=1;
  function sel(btn,step){
    btn.closest('.q-opts').querySelectorAll('.q-opt').forEach(o=>{o.classList.remove('sel');o.setAttribute('aria-pressed','false');});
    btn.classList.add('sel');btn.setAttribute('aria-pressed','true');
  }
  function nx(s){document.getElementById('s'+cs).classList.remove('active');cs=s;document.getElementById('s'+s).classList.add('active');dots(s);}
  function pv(s){document.getElementById('s'+cs).classList.remove('active');cs=s;document.getElementById('s'+s).classList.add('active');dots(s);}
  function res(){document.getElementById('s'+cs).classList.remove('active');document.getElementById('s-res').classList.add('active');for(let i=1;i<=5;i++){const d=document.getElementById('d'+i);d.classList.remove('active');d.classList.add('done');}}
  function dots(s){for(let i=1;i<=5;i++){const d=document.getElementById('d'+i);d.classList.remove('active','done');if(i<s)d.classList.add('done');else if(i===s)d.classList.add('active');}}

  /* ── EMAIL ── */
  function emailSub(){
    const em=document.getElementById('ei').value.trim(),nm=document.getElementById('en').value.trim();
    if(!em||!em.includes('@')){document.getElementById('ei').focus();return;}
    document.querySelector('.eml-form').innerHTML=`<div style="text-align:center;padding:2rem 0;"><div style="width:52px;height:52px;background:rgba(245,170,46,.18);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 1.25rem;"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--amber-lt)" stroke-width="1.5" aria-hidden="true"><path stroke-linecap="round" d="M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg></div><h3 style="font-family:var(--ff-serif);font-size:1.5rem;color:white;margin-bottom:.5rem;">Welcome${nm?', '+nm:''}.</h3><p style="font-size:.87rem;color:rgba(255,255,255,.55);line-height:1.75;">You're in. Watch for your first Consultation Monday this week — no overwhelm, just clarity.</p></div>`;
  }

  /* ════════════════════════════════════════════
     SENSORY LAYER
  ════════════════════════════════════════════ */

  /* ── 1. SCROLL PROGRESS BAR ── */
  const progressBar = document.getElementById('progress-bar');
  window.addEventListener('scroll', () => {
    const h = document.documentElement;
    const pct = (scrollY / (h.scrollHeight - h.clientHeight)) * 100;
    progressBar.style.width = pct + '%';
  }, {passive:true});

  /* ── 2. FLOATING BOTANICAL PARTICLES ── */
  (function(){
    const canvas = document.getElementById('particles-canvas');
    const ctx = canvas.getContext('2d');
    let W, H, particles = [], raf;
    const REDUCED = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    function resize(){
      W = canvas.width  = window.innerWidth;
      H = canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize, {passive:true});

    // Particle types: dot, circle-outline, small-cross
    class Particle {
      constructor(){this.reset(true);}
      reset(init=false){
        this.x = Math.random()*W;
        this.y = init ? Math.random()*H : H + 20;
        this.size  = Math.random()*2.5 + 0.5;
        this.speed = Math.random()*0.25 + 0.05;
        this.opacity = Math.random()*0.35 + 0.05;
        this.drift = (Math.random()-0.5)*0.3;
        this.type  = Math.floor(Math.random()*3); // 0=dot, 1=ring, 2=cross
        this.color = Math.random() > 0.6 ? '#3264BF' : Math.random()>0.5 ? '#F29504' : '#9A9278';
        this.rotation = Math.random()*Math.PI*2;
        this.rotSpeed = (Math.random()-0.5)*0.02;
      }
      update(){
        this.y -= this.speed;
        this.x += this.drift;
        this.rotation += this.rotSpeed;
        if(this.y < -20 || this.x < -20 || this.x > W+20) this.reset();
      }
      draw(){
        ctx.save();
        ctx.globalAlpha = this.opacity;
        ctx.strokeStyle = this.color;
        ctx.fillStyle   = this.color;
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rotation);
        if(this.type===0){
          ctx.beginPath();ctx.arc(0,0,this.size,0,Math.PI*2);ctx.fill();
        } else if(this.type===1){
          ctx.beginPath();ctx.arc(0,0,this.size*2,0,Math.PI*2);
          ctx.lineWidth=0.6;ctx.stroke();
        } else {
          const s=this.size*1.5;
          ctx.lineWidth=0.8;
          ctx.beginPath();ctx.moveTo(-s,0);ctx.lineTo(s,0);ctx.stroke();
          ctx.beginPath();ctx.moveTo(0,-s);ctx.lineTo(0,s);ctx.stroke();
        }
        ctx.restore();
      }
    }

    if(!REDUCED){
      for(let i=0;i<55;i++) particles.push(new Particle());
      function loop(){
        ctx.clearRect(0,0,W,H);
        particles.forEach(p=>{p.update();p.draw();});
        raf = requestAnimationFrame(loop);
      }
      loop();
    }
  })();

  /* ── 3. FOREST AMBIENT SOUND ── */
  /* Audio: forest-ambient.mp3 — Pixabay license, royalty-free, no attribution required.
     Source: prem_adhikary on Pixabay (mountain-forest-high-quality-sound).
     Served from Shopify CDN via theme assets — no CORS issues. */
  (function(){
    var btn    = document.getElementById('sound-toggle');
    var ripple = document.querySelector('.sound-ripple');
    if(!btn) return;

    var audio     = null;
    var isPlaying = false;
    var fadeTimer = null;

    // Get the asset URL from the data attribute set in theme.liquid
    var src = btn.getAttribute('data-stream-src') || '';

    function initAudio(){
      if(audio) return;
      if(!src) return;
      audio        = new Audio(src);
      audio.loop   = true;
      audio.volume = 0;
      audio.preload = 'auto';
      audio.addEventListener('error', function(){
        console.warn('beUNSCRIPTED: forest audio failed to load —', src);
      });
      audio.load();
    }

    function clearFade(){
      if(fadeTimer){ clearInterval(fadeTimer); fadeTimer = null; }
    }

    function fadeTo(target, ms, onDone){
      clearFade();
      if(!audio) return;
      var start = audio.volume;
      var steps = 60;
      var iv    = ms / steps;
      var delta = (target - start) / steps;
      var step  = 0;
      fadeTimer = setInterval(function(){
        step++;
        if(!audio){ clearFade(); return; }
        audio.volume = Math.max(0, Math.min(1, start + delta * step));
        if(step >= steps){
          clearFade();
          if(audio) audio.volume = target;
          if(onDone) onDone();
        }
      }, iv);
    }

    function startPlay(){
      if(!audio){ initAudio(); }
      if(!audio) return;
      audio.currentTime = 0;
      audio.volume = 0;
      audio.play().then(function(){
        fadeTo(0.72, 4000);  // gentle 4 second fade in
        setUI(true);
        isPlaying = true;
        sessionStorage.setItem('bu_sound', '1');
      }).catch(function(err){
        console.warn('beUNSCRIPTED: play() failed —', err.message);
        setUI(false);
        isPlaying = false;
      });
    }

    function startPause(){
      fadeTo(0, 2000, function(){
        if(audio) audio.pause();
      });
      setUI(false);
      isPlaying = false;
      sessionStorage.removeItem('bu_sound');
    }

    function setUI(on){
      btn.classList.toggle('playing', on);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on
        ? 'Pause forest sounds'
        : 'Play forest sounds — calming nature ambience');
      if(ripple) ripple.classList.toggle('active', on);
      var lbl = document.getElementById('sound-label');
      /* label hidden — icon only */
    }

    // Pre-load silently on page ready
    initAudio();

    // Resume across page navigation if was playing before
    if(sessionStorage.getItem('bu_sound') === '1'){
      setUI(true);
      setTimeout(function(){ startPlay(); }, 400);
    }

    btn.addEventListener('click', function(){
      if(isPlaying){
        startPause();
      } else {
        startPlay();
      }
    });

    // Set initial label
    var lbl = document.getElementById('sound-label');
    /* label hidden — icon only */
  })();

  /* ── 4. MAGNETIC BUTTON EFFECT ── */
  (function(){
    if(!window.matchMedia('(hover:hover)and(pointer:fine)').matches) return;
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    document.querySelectorAll('.btn,.prod-btn,.q-next,.eml-btn,.nav-cta').forEach(btn=>{
      btn.addEventListener('mousemove', e=>{
        const r = btn.getBoundingClientRect();
        const cx = r.left + r.width/2;
        const cy = r.top  + r.height/2;
        const dx = (e.clientX - cx) * 0.28;
        const dy = (e.clientY - cy) * 0.28;
        btn.style.transform = `translate(${dx}px,${dy}px)`;
      });
      btn.addEventListener('mouseleave', ()=>{
        btn.style.transform = '';
      });
    });
  })();

  /* ── 5. CLICK RIPPLE (visual touch feedback) ── */
  document.addEventListener('click', e=>{
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    const el = e.target.closest('button,a,.btn,.prod-btn');
    if(!el) return;
    const r = document.createElement('div');
    r.className='ripple-effect';
    const s = 60;
    r.style.cssText=`width:${s}px;height:${s}px;left:${e.clientX-s/2}px;top:${e.clientY-s/2}px;`;
    document.body.appendChild(r);
    r.addEventListener('animationend',()=>r.remove());
  });

  /* ── 6. HAPTIC FEEDBACK (mobile) ── */
  document.querySelectorAll('.btn,.prod-btn,.q-next,.eml-btn').forEach(btn=>{
    btn.addEventListener('click',()=>{
      if('vibrate' in navigator){
        try{ navigator.vibrate([8]); }catch(e){}
      }
    });
  });

  /* ── 7. SOFT UI CLICK SOUNDS (Web Audio, synthesised — no files) ── */
  (function(){
    let _ac = null;
    function getAC(){
      if(!_ac) _ac = new (window.AudioContext||window.webkitAudioContext)();
      return _ac;
    }
    function playTone(freq=440, type='sine', dur=0.08, vol=0.06){
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      try{
        const ac = getAC();
        if(ac.state==='suspended') return; // only play if user already interacted
        const osc = ac.createOscillator();
        const g   = ac.createGain();
        osc.type=type; osc.frequency.value=freq;
        g.gain.setValueAtTime(vol, ac.currentTime);
        g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime+dur);
        osc.connect(g); g.connect(ac.destination);
        osc.start(); osc.stop(ac.currentTime+dur+0.01);
      } catch(e){}
    }

    // Hover tone on nav links (barely audible)
    document.querySelectorAll('.nav-links a').forEach(a=>{
      a.addEventListener('mouseenter', ()=> playTone(800,'sine',0.05,0.03));
    });

    // Button click — soft satisfying click tone
    document.querySelectorAll('.btn,.prod-btn').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        playTone(440,'triangle',0.12,0.07);
        // Add heartbeat pulse class
        btn.classList.add('pulse');
        btn.addEventListener('animationend',()=>btn.classList.remove('pulse'),{once:true});
      });
    });

    // Quiz option select — gentle confirm tone
    document.querySelectorAll('.q-opt').forEach(opt=>{
      opt.addEventListener('click', ()=> playTone(523,'sine',0.1,0.05));
    });

    // Quiz next — ascending tone
    document.querySelectorAll('.q-next').forEach(btn=>{
      btn.addEventListener('click', ()=> playTone(660,'sine',0.1,0.05));
    });
  })();

  /* ── 8. HERO MOUSE-PARALLAX (depth on mosaic cells) ── */
  (function(){
    if(!window.matchMedia('(hover:hover)and(pointer:fine)').matches) return;
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    const hero = document.querySelector('.h-right');
    if(!hero) return;
    const cells = hero.querySelectorAll('.mc');
    const depths = [0.012, -0.018, 0.015, -0.01]; // different parallax depths per cell

    document.addEventListener('mousemove', e=>{
      const cx = window.innerWidth/2, cy = window.innerHeight/2;
      const dx = e.clientX - cx, dy = e.clientY - cy;
      cells.forEach((cell, i)=>{
        const d = depths[i];
        cell.style.transform = `translate(${dx*d}px, ${dy*d}px)`;
      });
    },{passive:true});
  })();

  /* ── 9. BREATHING SCROLL SPEED (subtle page weight) ── */
  (function(){
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    // Subtle grain opacity shifts with scroll depth
    const grain = document.getElementById('grain');
    window.addEventListener('scroll',()=>{
      const depth = scrollY / (document.body.scrollHeight - window.innerHeight);
      // Grain gets ever-so-slightly more pronounced as you scroll deeper
      grain.style.opacity = 0.035 + depth * 0.025;
    },{passive:true});
  })();

  /* ── 10. FIRST LOAD SCENT INTRO — text reveals with stagger ── */
  (function(){
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    // Animate hero heading words with staggered slide-up
    const hed = document.querySelector('.h-hed');
    if(!hed) return;
    // Already handled by CSS fadeUp — add extra word-by-word stagger
    const words = hed.innerHTML.split(' ');
    hed.innerHTML = words.map((w,i)=>
      `<span style="display:inline-block;animation:fadeUp .7s var(--ease) ${0.35+i*0.07}s both">${w}</span>`
    ).join(' ');
  })();